import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { ChangeEventHandler, useState } from "react";
import { FormInputProps } from "./FormInput";

type PasswordProps = FormInputProps<string> & { label?: string };

export default function Password({ value, onChange, label }: PasswordProps) {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () =>
    setShowPassword((show: boolean) => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
  };
  label = label || "Password";

  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel>{label}</InputLabel>
      <OutlinedInput
        type={showPassword ? "text" : "password"}
        value={value}
        onChange={onChange as ChangeEventHandler}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
            </IconButton>
          </InputAdornment>
        }
        label={label}
      />
    </FormControl>
  );
}
